import axios from '../axios';

const   fetchMissionExperts = (setExperts,mid)=>{
    axios.get(`${'experts'}`,{params:{missionId : mid}}).then(
        (res) => {
            console.log(`i made the request with ${mid}`);
            console.log(res.data);
            //construire une list pour etre utilisé dans selectComponent
            let newArr=[];
            res?.data.map((expert) => {
                newArr.push({value:expert?._id,label:expert?.persoData?.nom});
            });
            setExperts(newArr);
        },
        (err) => {
            console.error('error in getting experts',err);
        }
    );

};

const fetchExperts =(setExperts)=>{
    axios.get(`${'experts'}`).then(
        (res) => {

            console.log(res.data);
            setExperts(res.data);

        },
        (err) => {
            console.error('error in getting experts',err);
        }
    );

};
const createExpert = (formValues) => {
    axios.post(`${'experts'}`, formValues).then(
        (res) => {
            console.log(res.data);
        },
        (err) => {
            console.error(err);
        }
    );
};
export {createExpert,fetchExperts,fetchMissionExperts } ;